import AppLocationsIndex from "./location.vue";
import AppLocationsList from "./list/list.vue";
import AppLocationsItem from "./item/item.vue";

const routes = [
  {
    path: "locations",
    component: AppLocationsIndex,
    meta: {
      auth: {
        roles: "location.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "location.index",
        component: AppLocationsList,
        meta: {
          auth: {
            roles: "location.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "location.create",
        component: AppLocationsItem,
        meta: {
          auth: {
            roles: "location.create",
            redirect: { name: "location.index" }
          }
        }
      },
      {
        path: ":id",
        name: "location.edit",
        component: AppLocationsItem,
        meta: {
          auth: {
            roles: "location.update",
            redirect: { name: "location.index" }
          }
        }
      }
    ]
  }
];

export default routes;
